'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * @desc 解决浮动运算问题，避免小数点后产生多位数和计算精度损失。
 * 问题示例：2.3 + 2.4 = 4.699999999999999，1.0 - 0.9 = 0.09999999999999998
 */
/**
 * 把错误的数据转正
 * strip(0.09999999999999998)=0.1
 */
function strip(num, precision) {
    if (precision === void 0) { precision = 15; }
    return +parseFloat(Number(num).toPrecision(precision));
}
/**
 * Return digits length of a number
 * @param {*number} num Input number
 */
function digitLength(num) {
    // Get digit length of e
    var eSplit = num.toString().split(/[eE]/);
    var len = (eSplit[0].split('.')[1] || '').length - +(eSplit[1] || 0);
    return len > 0 ? len : 0;
}
/**
 * 把小数转成整数，支持科学计数法。如果是小数则放大成整数
 * @param {*number} num 输入数
 */
function float2Fixed(num) {
    if (num.toString().indexOf('e') === -1) {
        return Number(num.toString().replace('.', ''));
    }
    var dLen = digitLength(num);
    return dLen > 0 ? strip(Number(num) * Math.pow(10, dLen)) : Number(num);
}
/**
 * 检测数字是否越界，如果越界给出提示
 * @param {*number} num 输入数
 */
function checkBoundary(num) {
    if (_boundaryCheckingState) {
        if (num > Number.MAX_SAFE_INTEGER || num < Number.MIN_SAFE_INTEGER) {
            console.warn(num + " is beyond boundary when transfer to integer, the results may not be accurate");
        }
    }
}
/**
 * 迭代操作
 */
function iteratorOperation(arr, operation) {
    var num1 = arr[0], num2 = arr[1], others = arr.slice(2);
    var res = operation(num1, num2);
    others.forEach(function (num) {
        res = operation(res, num);
    });
    return res;
}
/**
 * 精确乘法
 */
function times() {
    var nums = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        nums[_i] = arguments[_i];
    }
    if (nums.length > 2) {
        return iteratorOperation(nums, times);
    }
    var num1 = nums[0], num2 = nums[1];
    var num1Changed = float2Fixed(num1);
    var num2Changed = float2Fixed(num2);
    var baseNum = digitLength(num1) + digitLength(num2);
    var leftValue = num1Changed * num2Changed;
    checkBoundary(leftValue);
    return leftValue / Math.pow(10, baseNum);
}
/**
 * 精确加法
 */
function plus() {
    var nums = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        nums[_i] = arguments[_i];
    }
    if (nums.length > 2) {
        return iteratorOperation(nums, plus);
    }
    var num1 = nums[0], num2 = nums[1];
    // 取最大的小数位
    var baseNum = Math.pow(10, Math.max(digitLength(num1), digitLength(num2)));
    // 把小数都转为整数然后再计算
    return (times(num1, baseNum) + times(num2, baseNum)) / baseNum;
}
/**
 * 精确减法
 */
function minus() {
    var nums = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        nums[_i] = arguments[_i];
    }
    if (nums.length > 2) {
        return iteratorOperation(nums, minus);
    }
    var num1 = nums[0], num2 = nums[1];
    var baseNum = Math.pow(10, Math.max(digitLength(num1), digitLength(num2)));
    return (times(num1, baseNum) - times(num2, baseNum)) / baseNum;
}
/**
 * 精确除法
 */
function divide() {
    var nums = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        nums[_i] = arguments[_i];
    }
    if (nums.length > 2) {
        return iteratorOperation(nums, divide);
    }
    var num1 = nums[0], num2 = nums[1];
    var num1Changed = float2Fixed(num1);
    var num2Changed = float2Fixed(num2);
    checkBoundary(num1Changed);
    checkBoundary(num2Changed);
    // fix: 类似 10 ** -4 为 0.00009999999999999999，strip 修正
    return times(num1Changed / num2Changed, strip(Math.pow(10, digitLength(num2) - digitLength(num1))));
}
var _boundaryCheckingState = true;
/**
 * 是否进行边界检查，默认开启
 * @param flag 标记开关，true 为开启，false 为关闭，默认为 true
 */
function enableBoundaryChecking(flag) {
    if (flag === void 0) { flag = true; }
    _boundaryCheckingState = flag;
}

var MeasurementType;

(function (MeasurementType) {
  MeasurementType["coordinates"] = "coordinates";
  MeasurementType["length"] = "length";
  MeasurementType["mass"] = "mass";
  MeasurementType["pressure"] = "pressure";
  MeasurementType["speed"] = "speed";
  MeasurementType["temperature"] = "temperature";
})(MeasurementType || (MeasurementType = {}));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

const ROUND_MULTIPLIER = 10;

function round(value, roundAmount) {
  if (roundAmount === 0 || roundAmount === true) {
    return Math.round(value);
  }

  const factor = ROUND_MULTIPLIER ** roundAmount;
  return Math.round(value * factor) / factor;
}

function applyOptions(value, options) {
  if (options.round !== undefined && options.round !== false) {
    // TODO: verify round is 0> int
    return round(value, options.round);
  }

  return value;
}
function applyOptionsToDecimalCoordinates(value, options) {
  if (options.round !== undefined && options.round !== false) {
    // TODO: verify round is 0> int
    return {
      latitude: round(value.latitude, options.round),
      longitude: round(value.longitude, options.round)
    };
  }

  return value;
}
function applyOptionsToDegreesCoordinates(value, options) {
  if (options.round !== undefined && options.round !== false) {
    // TODO: verify round is 0> int
    return {
      latitude: _objectSpread2(_objectSpread2({}, value.latitude), {}, {
        seconds: round(value.latitude.seconds, options.round)
      }),
      longitude: _objectSpread2(_objectSpread2({}, value.longitude), {}, {
        seconds: round(value.longitude.seconds, options.round)
      })
    };
  }

  return value;
}

enableBoundaryChecking(false);
exports.CoordinatesUnit = void 0;

(function (CoordinatesUnit) {
  CoordinatesUnit["decimal"] = "decimal";
  CoordinatesUnit["degrees"] = "degrees";
})(exports.CoordinatesUnit || (exports.CoordinatesUnit = {}));

function createCoordinates(value, unit = exports.CoordinatesUnit.decimal) {
  switch (unit) {
    case exports.CoordinatesUnit.decimal:
      return {
        type: MeasurementType.coordinates,
        value
      };

    case exports.CoordinatesUnit.degrees:
      throw new Error(`${unit} is not implemented yet.`);

    default:
      throw new Error(`${unit} is not a supported length unit.`);
  }
}
function coordinatesToDecimal(coords, options = {}) {
  return applyOptionsToDecimalCoordinates(coords.value, options);
}

function coordinateToDegrees(coordinate) {
  return Math.floor(Math.abs(coordinate));
}

function coordinateToMinutes(coordinate) {
  return Math.floor(times(60, Math.abs(coordinate) - coordinateToDegrees(coordinate)));
}

function coordinateToSeconds(coordinate) {
  return times(3600, Math.abs(coordinate) - coordinateToDegrees(coordinate)) - times(60, coordinateToMinutes(coordinate));
}

function coordinatesToDegrees({
  value: {
    latitude,
    longitude
  }
}, options = {}) {
  const coords = {
    latitude: {
      degrees: coordinateToDegrees(latitude),
      minutes: coordinateToMinutes(latitude),
      seconds: coordinateToSeconds(latitude),
      direction: latitude >= 0 ? 'N' : 'S'
    },
    longitude: {
      degrees: coordinateToDegrees(longitude),
      minutes: coordinateToMinutes(longitude),
      seconds: coordinateToSeconds(longitude),
      direction: longitude >= 0 ? 'E' : 'W'
    }
  };
  return applyOptionsToDegreesCoordinates(coords, options);
}

const CENTIMETRES_IN_METRE = 100;
const FEET_IN_METRE = 3.28084;
const INCHES_IN_METRE = 39.3701;
const POUNDS_IN_KILOGRAM = 2.2046;
const GRAMS_IN_KILOGRAM = 1000;
const OUNCES_IN_KILOGRAM = 35.2739619;
const PASCALS_IN_BAR = 100000;
const PASCALS_IN_HECTOPASCAL = 100;
const PASCALS_IN_MILLIBAR = 100;
const PASCALS_IN_MMHG = 133.322;
const SECONDS_IN_HOUR = 3600;
const KILOMETRES_IN_METRE = 0.001;
const MILES_IN_METRE = 0.000621371;
const NAUTICAL_MILES_IN_METRE = 0.000539957;

enableBoundaryChecking(false);
exports.LengthUnit = void 0;

(function (LengthUnit) {
  LengthUnit["metres"] = "m";
  LengthUnit["centimetres"] = "cm";
  LengthUnit["feet"] = "ft";
  LengthUnit["inches"] = "in";
  LengthUnit["kilometres"] = "km";
  LengthUnit["miles"] = "miles";
})(exports.LengthUnit || (exports.LengthUnit = {}));

function centimetresToMetres(value) {
  return divide(value, CENTIMETRES_IN_METRE);
}

function feetToMetres(value) {
  return divide(value, FEET_IN_METRE);
}

function inchesToMetres(value) {
  return divide(value, INCHES_IN_METRE);
}

function kilometresToMetres(value) {
  return divide(value, KILOMETRES_IN_METRE);
}

function milesToMetres(value) {
  return divide(value, MILES_IN_METRE);
}

function createLength(value, unit = exports.LengthUnit.metres) {
  switch (unit) {
    case exports.LengthUnit.metres:
      return {
        type: MeasurementType.length,
        value
      };

    case exports.LengthUnit.centimetres:
      return {
        type: MeasurementType.length,
        value: centimetresToMetres(value)
      };

    case exports.LengthUnit.feet:
      return {
        type: MeasurementType.length,
        value: feetToMetres(value)
      };

    case exports.LengthUnit.inches:
      return {
        type: MeasurementType.length,
        value: inchesToMetres(value)
      };

    case exports.LengthUnit.kilometres:
      return {
        type: MeasurementType.length,
        value: kilometresToMetres(value)
      };

    case exports.LengthUnit.miles:
      return {
        type: MeasurementType.length,
        value: milesToMetres(value)
      };

    default:
      throw new Error(`${unit} is not a supported length unit.`);
  }
}
function lengthToMetres(_length, options = {}) {
  return applyOptions(_length.value, options);
}
function lengthToCentimetres(_length, options = {}) {
  return applyOptions(times(_length.value, CENTIMETRES_IN_METRE), options);
}
function lengthToFeet(_length, options = {}) {
  return applyOptions(times(_length.value, FEET_IN_METRE), options);
}
function lengthToInches(_length, options = {}) {
  return applyOptions(times(_length.value, INCHES_IN_METRE), options);
}
function lengthToKilometres(_length, options = {}) {
  return applyOptions(times(_length.value, KILOMETRES_IN_METRE), options);
}
function lengthToMiles(_length, options = {}) {
  return applyOptions(times(_length.value, MILES_IN_METRE), options);
}

enableBoundaryChecking(false);
exports.MassUnit = void 0;

(function (MassUnit) {
  MassUnit["kilograms"] = "kg";
  MassUnit["grams"] = "g";
  MassUnit["pounds"] = "lb";
  MassUnit["ounces"] = "oz";
})(exports.MassUnit || (exports.MassUnit = {}));

function gramsToKilograms(value) {
  return divide(value, GRAMS_IN_KILOGRAM);
}

function poundsToKilograms(value) {
  return divide(value, POUNDS_IN_KILOGRAM);
}

function ouncesToKilograms(value) {
  return divide(value, OUNCES_IN_KILOGRAM);
}

function createMass(value, unit = exports.MassUnit.kilograms) {
  switch (unit) {
    case exports.MassUnit.kilograms:
      return {
        type: MeasurementType.mass,
        value
      };

    case exports.MassUnit.grams:
      return {
        type: MeasurementType.mass,
        value: gramsToKilograms(value)
      };

    case exports.MassUnit.pounds:
      return {
        type: MeasurementType.mass,
        value: poundsToKilograms(value)
      };

    case exports.MassUnit.ounces:
      return {
        type: MeasurementType.mass,
        value: ouncesToKilograms(value)
      };

    default:
      throw new Error(`${unit} is not a supported mass unit.`);
  }
}
function massToKilograms(_mass, options = {}) {
  return applyOptions(_mass.value, options);
}
function massToGrams(_mass, options = {}) {
  return applyOptions(times(_mass.value, GRAMS_IN_KILOGRAM), options);
}
function massToPounds(_mass, options = {}) {
  return applyOptions(times(_mass.value, POUNDS_IN_KILOGRAM), options);
}
function massToOunces(_mass, options = {}) {
  return applyOptions(times(_mass.value, OUNCES_IN_KILOGRAM), options);
}

enableBoundaryChecking(false);
exports.PressureUnit = void 0;

(function (PressureUnit) {
  PressureUnit["pascal"] = "pa";
  PressureUnit["hectopascal"] = "hpa";
  PressureUnit["bar"] = "bar";
  PressureUnit["millibar"] = "mbar";
  PressureUnit["mmhg"] = "mmhg";
})(exports.PressureUnit || (exports.PressureUnit = {}));

function hectopascalToPascal(value) {
  return times(value, PASCALS_IN_HECTOPASCAL);
}

function barToPascal(value) {
  return times(value, PASCALS_IN_BAR);
}

function millibarToPascal(value) {
  return times(value, PASCALS_IN_MILLIBAR);
}

function mmhgToPascal(value) {
  return times(value, PASCALS_IN_MMHG);
}

function createPressure(value, unit = exports.PressureUnit.pascal) {
  switch (unit) {
    case exports.PressureUnit.pascal:
      return {
        type: MeasurementType.pressure,
        value
      };

    case exports.PressureUnit.hectopascal:
      return {
        type: MeasurementType.pressure,
        value: hectopascalToPascal(value)
      };

    case exports.PressureUnit.bar:
      return {
        type: MeasurementType.pressure,
        value: barToPascal(value)
      };

    case exports.PressureUnit.millibar:
      return {
        type: MeasurementType.pressure,
        value: millibarToPascal(value)
      };

    case exports.PressureUnit.mmhg:
      return {
        type: MeasurementType.pressure,
        value: mmhgToPascal(value)
      };

    default:
      throw new Error(`${unit} is not a supported pressure unit.`);
  }
}
function pressureToPascal(pressure, options = {}) {
  return applyOptions(pressure.value, options);
}
function pressureToHectopascal(pressure, options = {}) {
  return applyOptions(divide(pressure.value, PASCALS_IN_HECTOPASCAL), options);
}
function pressureToBar(pressure, options = {}) {
  return applyOptions(divide(pressure.value, PASCALS_IN_BAR), options);
}
function pressureToMillibar(pressure, options = {}) {
  return applyOptions(divide(pressure.value, PASCALS_IN_MILLIBAR), options);
}
function pressureToMmhg(pressure, options = {}) {
  return applyOptions(divide(pressure.value, PASCALS_IN_MMHG), options);
}

enableBoundaryChecking(false);
exports.SpeedUnit = void 0;

(function (SpeedUnit) {
  SpeedUnit["metresPerSecond"] = "ms";
  SpeedUnit["kilometresPerHour"] = "kmh";
  SpeedUnit["milesPerHour"] = "mph";
  SpeedUnit["knots"] = "knot";
  SpeedUnit["feetPerSecond"] = "fps";
})(exports.SpeedUnit || (exports.SpeedUnit = {}));

function kmhToMs(value) {
  return divide(value, SECONDS_IN_HOUR, KILOMETRES_IN_METRE);
}

function mphToMs(value) {
  return divide(value, SECONDS_IN_HOUR, MILES_IN_METRE);
}

function knotsToMs(value) {
  return divide(value, SECONDS_IN_HOUR, NAUTICAL_MILES_IN_METRE);
}

function fpsToMs(value) {
  // eslint-disable-next-line no-magic-numbers
  return divide(value, FEET_IN_METRE);
}

function createSpeed(value, unit = exports.SpeedUnit.metresPerSecond) {
  switch (unit) {
    case exports.SpeedUnit.metresPerSecond:
      return {
        type: MeasurementType.speed,
        value
      };

    case exports.SpeedUnit.kilometresPerHour:
      return {
        type: MeasurementType.speed,
        value: kmhToMs(value)
      };

    case exports.SpeedUnit.milesPerHour:
      return {
        type: MeasurementType.speed,
        value: mphToMs(value)
      };

    case exports.SpeedUnit.knots:
      return {
        type: MeasurementType.speed,
        value: knotsToMs(value)
      };

    case exports.SpeedUnit.feetPerSecond:
      return {
        type: MeasurementType.speed,
        value: fpsToMs(value)
      };

    default:
      throw new Error(`${unit} is not a supported speed unit.`);
  }
}
function speedToMs(speed, options = {}) {
  return applyOptions(speed.value, options);
}
function speedToKmh(speed, options = {}) {
  return applyOptions(times(speed.value, SECONDS_IN_HOUR, KILOMETRES_IN_METRE), options);
}
function speedToMph(speed, options = {}) {
  return applyOptions(times(speed.value, SECONDS_IN_HOUR, MILES_IN_METRE), options);
}
function speedToKnots(speed, options = {}) {
  return applyOptions(times(speed.value, SECONDS_IN_HOUR, NAUTICAL_MILES_IN_METRE), options);
}
function speedToFps(speed, options = {}) {
  return applyOptions(times(speed.value, FEET_IN_METRE), options);
}

enableBoundaryChecking(false);
exports.TemperatureUnit = void 0;

(function (TemperatureUnit) {
  TemperatureUnit["kelvin"] = "k";
  TemperatureUnit["celsius"] = "c";
  TemperatureUnit["fahrenheit"] = "f";
})(exports.TemperatureUnit || (exports.TemperatureUnit = {}));

const KELIN_OFFSET = 273.15;

function celsiusToKelvin(value) {
  return plus(value, KELIN_OFFSET);
}

function fahrenheitToKelvin(value) {
  // eslint-disable-next-line no-magic-numbers
  return plus(times(minus(value, 32), divide(5, 9)), KELIN_OFFSET);
}

function createTemperature(value, unit = exports.TemperatureUnit.kelvin) {
  switch (unit) {
    case exports.TemperatureUnit.kelvin:
      return {
        type: MeasurementType.temperature,
        value
      };

    case exports.TemperatureUnit.celsius:
      return {
        type: MeasurementType.temperature,
        value: celsiusToKelvin(value)
      };

    case exports.TemperatureUnit.fahrenheit:
      return {
        type: MeasurementType.temperature,
        value: fahrenheitToKelvin(value)
      };

    default:
      throw new Error(`${unit} is not a supported temperature unit.`);
  }
}
function temperatureToKelvin(temperature, options = {}) {
  return applyOptions(temperature.value, options);
}
function temperatureToCelsius(temperature, options = {}) {
  return applyOptions(minus(temperature.value, KELIN_OFFSET), options);
}
function temperatureToFahrenheit(temperature, options = {}) {
  return applyOptions( // eslint-disable-next-line no-magic-numbers
  plus(times(minus(temperature.value, KELIN_OFFSET), divide(9, 5)), 32), options);
}

exports.coordinatesToDecimal = coordinatesToDecimal;
exports.coordinatesToDegrees = coordinatesToDegrees;
exports.createCoordinates = createCoordinates;
exports.createLength = createLength;
exports.createMass = createMass;
exports.createPressure = createPressure;
exports.createSpeed = createSpeed;
exports.createTemperature = createTemperature;
exports.lengthToCentimetres = lengthToCentimetres;
exports.lengthToFeet = lengthToFeet;
exports.lengthToInches = lengthToInches;
exports.lengthToKilometres = lengthToKilometres;
exports.lengthToMetres = lengthToMetres;
exports.lengthToMiles = lengthToMiles;
exports.massToGrams = massToGrams;
exports.massToKilograms = massToKilograms;
exports.massToOunces = massToOunces;
exports.massToPounds = massToPounds;
exports.pressureToBar = pressureToBar;
exports.pressureToHectopascal = pressureToHectopascal;
exports.pressureToMillibar = pressureToMillibar;
exports.pressureToMmhg = pressureToMmhg;
exports.pressureToPascal = pressureToPascal;
exports.speedToFps = speedToFps;
exports.speedToKmh = speedToKmh;
exports.speedToKnots = speedToKnots;
exports.speedToMph = speedToMph;
exports.speedToMs = speedToMs;
exports.temperatureToCelsius = temperatureToCelsius;
exports.temperatureToFahrenheit = temperatureToFahrenheit;
exports.temperatureToKelvin = temperatureToKelvin;
